import { cn } from '~/utils/cn';

interface PropsSkeleton {
  className?: string;
  width?: number | string;
  height?: number | string;
  rounded?: 'none' | 'sm' | 'md' | 'lg' | 'full';
}

export default function Skeleton({ className, width, height, rounded = 'md' }: PropsSkeleton) {
  const radius =
    rounded === 'full'
      ? 'rounded-full'
      : rounded === 'lg'
        ? 'rounded-[16px]'
        : rounded === 'md'
          ? 'rounded-[8px]'
          : rounded === 'sm'
            ? 'rounded-[4px]'
            : '';

  return (
    <div
      className={cn(
        'relative overflow-hidden bg-intense-03',
        radius,
        className,
      )}
      style={{ width, height }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-intense-02 to-transparent animate-shimmer" />
    </div>
  );
}
